// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"general_ant-form-item_3LcS1"};